import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  DialogActions,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import LicenceInput from "./components/licence/LicenceInput";
import { useTranslation } from "react-i18next";
import { setLicence } from "./redux/actions/universalActions";
import { useDispatch } from "react-redux";
import { anonAuthServiceClient as axios } from "./AxiosClient";
import { useSnackbar } from "notistack";
import ActionButton from "./components/ActionButton";
import psl from "psl";
import "./sa-icons.css";

function LicenceDialog(props) {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const dispatch = useDispatch();
  const [key, setKey] = useState("");
  const [saving, setSaving] = useState(false);
  const [licenceValid, setLicenceValid] = useState(false);
  const [licenced, setLicenced] = useState(false);

  const licenseOrganization = () => {
    setSaving(true);
    let parsed = psl.parse(window.location.hostname);
    let organization = parsed.subdomain;
    if (
      !organization ||
      organization === "uksv6" ||
      organization === "uksv6-test"
    ) {
      organization = "demo";
    }
    axios
      .post(`/licence/${organization}/license`, { key })
      .then((res) => {
        dispatch(setLicence(res.data));
        setKey("");
        setSaving(false);
        setLicenced(true);
      })
      .catch((err) => {
        enqueueSnackbar(t("error_occurred_generic"), { variant: "error" });
        setSaving(false);
        setLicenced(false);
      });
  };

  return (
    <Dialog
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      <DialogTitle id="alert-dialog-title">
        {t("licence_modal_header")}
      </DialogTitle>
      <DialogContent>
        {licenced ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ textAlign: "center" }}>
              <div class="sa">
                <div class="sa-success">
                  <div class="sa-success-tip" />
                  <div class="sa-success-long" />
                  <div class="sa-success-placeholder" />
                  <div class="sa-success-fix" />
                </div>
              </div>
              <Typography variant="h5" style={{ marginBottom: 15 }}>
                {t("licence_added_success")}
              </Typography>
              <Typography style={{ marginBottom: 15 }}>
                {t("licence_added_success_subheader")}
              </Typography>
            </div>
          </div>
        ) : (
          <>
            <Typography gutterBottom>
              {t("enter_licence_key_licence_dialog")}
            </Typography>
            <div style={{ display: "flex" }}>
              <LicenceInput
                setKey={(key) => setKey(key)}
                licenceKey={key}
                setLicenceValid={(valid) => setLicenceValid(valid)}
              />
              <ActionButton
                variant="contained"
                color="primary"
                disabled={!licenceValid}
                onClick={() => licenseOrganization()}
                loading={saving}
                style={{ marginLeft: 15, marginTop: 12 }}
              >
                {t("global_save")}
              </ActionButton>
            </div>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          onClick={() => history.push("/", { fromLogout: true })}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          disabled={!licenced}
          onClick={() => history.push("/", { fromLogout: true, error: null })}
        >
          Log in
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default LicenceDialog;
